import React from 'react'
import PropTypes from 'prop-types'

/** Server-chosen aggregate scalars as compact fd-metric KPIs (the "stats"). */
const CURRENCY_RE = /(revenue|spend|spent|sales|price|ltv|value|cost|cpo|amount)/i
const currency = (localStorage.getItem('userCurrency') || 'EUR').toUpperCase()

function labelFor(key) {
  if (key === 'row_count') return 'Rows'
  let prefix = ''
  let k = key
  if (k.startsWith('sum_')) {
    prefix = 'Total '
    k = k.slice(4)
  } else if (k.startsWith('avg_')) {
    prefix = 'Avg '
    k = k.slice(4)
  }
  k = k.replace(/_/g, ' ').trim()
  // avoid "Total total spent" when the metric name already carries the word
  if (prefix && k.toLowerCase().startsWith(prefix.trim().toLowerCase() + ' ')) prefix = ''
  const s = prefix + k
  return s.charAt(0).toUpperCase() + s.slice(1)
}

function formatValue(key, v) {
  if (v == null) return '—'
  if (typeof v === 'number') {
    if (CURRENCY_RE.test(key)) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 0 }).format(v)
      } catch (e) {
        /* fall through */
      }
    }
    return new Intl.NumberFormat().format(v)
  }
  return String(v)
}

// Scale the KPI value down as the formatted number gets longer, so long values
// (e.g. large currency totals) fit the compact metric box instead of spilling.
function valueFontSize(text) {
  const len = text.length
  if (len <= 6) return '32px'
  if (len <= 9) return '26px'
  if (len <= 12) return '21px'
  if (len <= 16) return '17px'
  return '14px'
}

export default function StatsRow({ aggregates }) {
  if (!aggregates || typeof aggregates !== 'object') return null
  const entries = Object.entries(aggregates)
  if (entries.length === 0) return null

  return (
    <div className="flex flex-wrap gap-3 mb-4">
      {entries.map(([key, value]) => {
        const display = formatValue(key, value)
        return (
          <div key={key} className="fd-metric" style={{ flex: '1 1 150px', maxWidth: '220px', minWidth: 0 }}>
            <div className="fd-metric__label">{labelFor(key)}</div>
            <div className="fd-metric__value" style={{ fontSize: valueFontSize(display), overflowWrap: 'anywhere' }}>
              {display}
            </div>
          </div>
        )
      })}
    </div>
  )
}

StatsRow.propTypes = { aggregates: PropTypes.object }
